import React, { useState } from 'react';
import '../css/FormTypesShowcase.css';

const FORM_TYPES = [
  {
    id: 'instant-price',
    number: '01',
    title: 'Instant price',
    eyebrow: 'Exact price + products',
    description:
      'Customers choose a product, answer its condition and specification questions, and receive an exact value before adding it to their cart.',
    video: '/videos/form-type-instant-price.mp4',
    videoLabel: 'Instant price customer form walkthrough',
    highlights: ['Product options', 'Exact value'],
  },
  {
    id: 'price-range',
    number: '02',
    title: 'Price range',
    eyebrow: 'Product-led estimate',
    description:
      'Customers select their product and immediately see a minimum–maximum estimate. Your team confirms the final value after inspection.',
    video: '/videos/form-type-price-range.mp4',
    videoLabel: 'Price range customer form walkthrough',
    highlights: ['Product catalogue', 'Flexible estimate'],
  },
  {
    id: 'quote-only',
    number: '03',
    title: 'Quote only',
    eyebrow: 'Request an offer',
    description:
      'Collect item details, condition, attachments and your own questions, then reply with a tailored offer.',
    video: '/videos/form-type-quote-only.mp4',
    videoLabel: 'Quote-only customer form walkthrough',
    highlights: ['Custom questions', 'Manual offer'],
  },
];

const FormTypesShowcase = () => {
  const [active, setActive] = useState(0);
  const current = FORM_TYPES[active];

  return (
    <section className="form-types" aria-labelledby="form-types-title">
      <div className="form-types__inner">
        <div className="form-types__header">
          <p className="form-types__kicker">Flexible by design</p>
          <h2 id="form-types-title">Three ways to customise your form</h2>
          <p>
            Customise your form on your website based on how you buy from customer.
          </p>
        </div>

        <div className="form-types__tabs" role="tablist" aria-label="Buyback form types">
          {FORM_TYPES.map((formType, index) => (
            <button
              key={formType.id}
              type="button"
              role="tab"
              aria-selected={active === index}
              aria-controls={`form-type-panel-${formType.id}`}
              id={`form-type-tab-${formType.id}`}
              className={active === index ? 'is-active' : ''}
              onClick={() => setActive(index)}
            >
              <span>{formType.number}</span>
              {formType.title}
            </button>
          ))}
        </div>

        <div
          className="form-types__panel"
          role="tabpanel"
          id={`form-type-panel-${current.id}`}
          aria-labelledby={`form-type-tab-${current.id}`}
          key={current.id}
        >
          <div className="form-types__copy">
            <p className="form-types__eyebrow">{current.eyebrow}</p>
            <h3>{current.title}</h3>
            <p className="form-types__description">{current.description}</p>
            <ul aria-label={`${current.title} highlights`}>
              {current.highlights.map((highlight) => (
                <li key={highlight}>{highlight}</li>
              ))}
            </ul>
          </div>

          <div className="form-types__media">
            <video
              key={current.id}
              src={current.video}
              aria-label={current.videoLabel}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormTypesShowcase;
